// 法人（ユーザー）情報編集の定義リストを生成する（変更不可のテキストorインプットフィールドorセレクトボックス）
import React, { memo } from 'react';
import {
  ResponseDetailType,
  OfficesType,
  CorporateDataListType,
  ValidMessageType,
} from '../../ts/types/Corporate';
import ValidMessage from '../atoms/ValidMessage';
import { CorporationInfoFormatValue } from '../Common';

interface Props {
  item: CorporateDataListType;
  data: ResponseDetailType | undefined;
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelect?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  valid_message: ValidMessageType[];
  user_type_id?: string;
  handleChangeSelectState?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const CorporateCreateDefinitionDescription: React.FC<Props> = ({
  item,
  data,
  handleInput,
  handleBlur,
  handleSelect,
  valid_message,
  user_type_id,
}) => {
  /**
   * inputタグの初期値をセットする処理
   */
  const setDefaultValue = () => {
    // 法人ユーザーの場合はキー名にユーザータイプのidをセット
    const item_name = user_type_id ? item.name + '_' + user_type_id : item.name;
    return data?.corporate_information[item_name];
  };

  /**
   * セレクトボックスの値をセットする処理
   */
  const setSelectValue = () => {
    if (!data?.offices) return undefined;

    const index = data.offices.findIndex(
      item => item.code === data?.corporate_information.temp_bank_branch_cd
    );

    // 該当項目が見つからない場合はエラーになるため、undefinedを返す
    return data?.offices[index]?.code ?? undefined;
  };

  /**
   * バリデーションエラーがあるか判定する処理
   * @param name アイテムのキー名
   * @returns index
   */
  const findValidMessageIndex = (name: string) => {
    if (valid_message.length === 0) return -1;

    // 法人ユーザーの場合はキー名にユーザータイプのidをセットして探す
    const item_name = user_type_id ? name + '_' + user_type_id : name;
    return valid_message.findIndex((item: ValidMessageType) => item.form_name === item_name);
  };

  return (
    <>
      {item.type === 'default' && (
        <dd className="field_data">{data && CorporationInfoFormatValue(data.corporate_information[item.name], item.name)}</dd>
      )}
      {(item.type === 'text' || item.type === 'email') && (
        <dd className="field_data">
          <input
            className={`form-control w-100 ${findValidMessageIndex(item.name) !== -1 &&
              'form-control-error'}`}
            defaultValue={setDefaultValue()}
            value={setDefaultValue()}
            name={item.name}
            type={item.type}
            onChange={handleInput}
            onBlur={handleBlur}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.currentTarget.blur();
              }
            }}
          />
          {findValidMessageIndex(item.name) !== -1 && (
            <span className="valid_message">
              <ValidMessage message={valid_message[findValidMessageIndex(item.name)].message} />
            </span>
          )}
        </dd>
      )}
      {item.type === 'select' && (
        <dd className="field_data">
          <select className="form-control w-100" onChange={handleSelect} value={setSelectValue()}>
            {data &&
              data.offices?.map((item2: OfficesType) => (
                <option
                  key={item2.code}
                  value={item2.code}
                  onKeyPress={e => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      e.currentTarget.blur();
                    }
                  }}
                >
                  {item2.name}
                </option>
              ))}
          </select>
        </dd>
      )}
    </>
  );
};

export default memo(CorporateCreateDefinitionDescription);
